import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { Seo } from "@/components/Seo";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState("All");

  useEffect(() => {
    api.get("/products").then(({ data }) => setProducts(data));
  }, []);

  const categories = ["All", ...Array.from(new Set(products.map((p) => p.category)))];
  const filtered = category === "All" ? products : products.filter((p) => p.category === category);

  return (
    <>
      <Seo title="Shop Research Peptides | Just Peptides Supply" description="Browse high-purity, domestic-origin research peptides including BPC-157, CJC-1295/Ipamorelin, NAD+, Tesamorelin and more." path="/shop" />

      <section className="relative overflow-hidden border-b border-brand-navy/10 bg-brand-navy">
        {/* Molecular banner video (watermark cropped out, re-encoded) */}
        <video
          className="absolute inset-0 h-full w-full object-cover"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          aria-hidden="true"
        >
          <source src="/catalog-banner.webm" type="video/webm" />
          <source src="/catalog-banner.mp4" type="video/mp4" />
        </video>
        {/* Dark overlay keeps the white headline legible over the video */}
        <div className="absolute inset-0 bg-gradient-to-r from-brand-navy/92 via-brand-navy/72 to-brand-navy/45" aria-hidden="true" />
        <div className="relative mx-auto max-w-7xl px-5 lg:px-8 py-20 sm:py-24">
          <p className="font-mono-label text-xs uppercase tracking-[0.2em] text-cyan-300">Catalog</p>
          <h1 className="mt-2 font-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight drop-shadow-md">Research Peptides</h1>
          <p className="mt-4 max-w-2xl text-white/90 text-base leading-relaxed drop-shadow">
            All compounds are of domestic origin. Sold individually as lyophilized powder for research use — bacteriostatic water and syringes not included.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 lg:px-8 py-12">
        <div className="flex flex-wrap gap-2 mb-9">
          {categories.map((c) => (
            <button
              key={c}
              data-testid={`filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => setCategory(c)}
              className={`font-mono-label text-xs uppercase tracking-[0.12em] px-4 py-2 rounded-full border transition-colors ${
                category === c ? "bg-brand-navy text-white border-brand-navy" : "bg-white text-brand-navy/70 border-brand-navy/15 hover:border-brand-blue"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {filtered.map((p, i) => (
            <ProductCard key={p.slug} product={p} index={i} />
          ))}
        </div>
      </section>
    </>
  );
}
